"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distinctUntilChanged = distinctUntilChanged;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Subscriber2 = require("../Subscriber");

var _tryCatch = require("../util/tryCatch");

var _errorObject = require("../util/errorObject");

/* tslint:enable:max-line-length */

/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
  return function (source) {
    return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
  };
}

var DistinctUntilChangedOperator =
/*#__PURE__*/
function () {
  function DistinctUntilChangedOperator(compare, keySelector) {
    (0, _classCallCheck2.default)(this, DistinctUntilChangedOperator);
    this.compare = compare;
    this.keySelector = keySelector;
  }

  (0, _createClass2.default)(DistinctUntilChangedOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    }
  }]);
  return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var DistinctUntilChangedSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(DistinctUntilChangedSubscriber, _Subscriber);

  function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
    var _this;

    (0, _classCallCheck2.default)(this, DistinctUntilChangedSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DistinctUntilChangedSubscriber).call(this, destination));
    _this.keySelector = keySelector;
    _this.hasKey = false;

    if (typeof compare === 'function') {
      _this.compare = compare;
    }

    return _this;
  }

  (0, _createClass2.default)(DistinctUntilChangedSubscriber, [{
    key: "compare",
    value: function compare(x, y) {
      return x === y;
    }
  }, {
    key: "_next",
    value: function _next(value) {
      var keySelector = this.keySelector;
      var key = value;

      if (keySelector) {
        key = (0, _tryCatch.tryCatch)(this.keySelector)(value);

        if (key === _errorObject.errorObject) {
          return this.destination.error(_errorObject.errorObject.e);
        }
      }

      var result = false;

      if (this.hasKey) {
        result = (0, _tryCatch.tryCatch)(this.compare)(this.key, key);

        if (result === _errorObject.errorObject) {
          return this.destination.error(_errorObject.errorObject.e);
        }
      } else {
        this.hasKey = true;
      }

      if (Boolean(result) === false) {
        this.key = key;
        this.destination.next(value);
      }
    }
  }]);
  return DistinctUntilChangedSubscriber;
}(_Subscriber2.Subscriber);